import FormattedTemperature from './FormattedTemperature';

export default FormattedTemperature;
